import { mainSiteUrl } from '@/mocks/categories';

export default function FinalCTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dynamic%20aerial%20flat%20lay%20of%20diverse%20international%20trendy%20products%20including%20sneakers%20electronics%20accessories%20and%20fashion%20items%20arranged%20in%20circular%20pattern%20on%20bright%20white%20surface%2C%20bold%20colorful%20composition%20with%20confetti%2C%20modern%20e-commerce%20marketplace%20celebration%20aesthetic%2C%20vibrant%20energetic%20atmosphere%2C%20inclusive%20global%20shopping%20concept%20photography%2C%20highly%20detailed%20sharp%20focus&width=1600&height=700&seq=final-cta-v2&orientation=landscape"
              alt="YOYBUY Spreadsheet начать заказ"
              title="Начните использовать YOYBUY Spreadsheet"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/70 via-foreground-900/40 to-foreground-900/30"></div>
          </div>

          <div className="relative z-10 py-14 md:py-20 px-6 md:px-12 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-3">
              Начните использовать YOYBUY Spreadsheet уже сегодня
            </h2>
            <p className="text-base text-background-50/80 mb-8 max-w-lg mx-auto leading-relaxed">
              Сократите ошибки при заказах из Китая и экономьте часы времени с каждой покупкой.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 text-base font-semibold text-foreground-900 bg-background-50 hover:bg-background-100 rounded-full transition-all whitespace-nowrap no-underline"
              >
                Перейти к YOYBUY
                <i className="ri-arrow-right-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="/article/yoybuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-7 py-3.5 text-base font-semibold text-background-50 border border-background-50/40 hover:bg-background-50/10 rounded-full transition-all whitespace-nowrap no-underline"
              >
                Узнать больше
                <i className="ri-book-open-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}